<template>
    <div class="selectSeatWrap">
        <!-- <nav-bar></nav-bar> -->
        <div>
            <div class="header">
                <div class="movieInfo fc jc">
                    <h3>{{ movieInfo.moviename }}</h3>
                    <p>{{ cinemaName }}</p>
                    <p class="tc">
                        {{ formatTime }}（{{ movieInfo.edition }}）
                    </p>
                </div>
                <!-- 座位图例 -->
                <div class="legend fr ac jc">
                    <div class="fr ac">
                        <img
                            class="seatImg"
                            src="../../../static/imgs/movie/seat_sold.png"
                            alt
                        />
                        <span>已售</span>
                    </div>
                    <div v-show="!areaArr.length" class="fr ac">
                        <img
                            class="seatImg"
                            src="../../../static/imgs/movie/seat_selectable.png"
                            alt
                        />
                        <span>可选</span>
                    </div>
                    <div
                        class="fr ac"
                        v-for="(item, index) in areaArr"
                        :key="index"
                    >
                        <img class="seatImg" :src="picArr[index].path" alt />
                        <span>{{ item.realPrice }}</span>
                    </div>
                    <div class="fr ac">
                        <img
                            class="doubleSeatImg"
                            src="../../../static/imgs/movie/seat_couple.png"
                            alt
                        />
                        <span>情侣座</span>
                    </div>
                </div>
            </div>

            <!-- 座位 规则排列 -->
            <div v-if="seatInfo.regular" class="seatWrap">
                <!-- 座位行标 -->
                <ul class="rowMark">
                    <li v-for="(item, index) in rowArr" :key="index">
                        {{ item }}
                    </li>
                </ul>
                <div class="seatMapWrap" v-show="seatInfo.maxcolumn">
                    <div
                        class="screenWrap fc ac"
                        :style="
                            'width: ' +
                            (seatInfo.maxcolumn * 60 + 20) / 75 +
                            'rem;'
                        "
                    >
                        <span class="screen"></span>
                        <span class="txt">{{ movieInfo.roomname }} 银幕</span>
                    </div>
                    <div
                        class="seatMap"
                        :style="
                            'width: ' +
                            (seatInfo.maxcolumn * 60 + 20) / 75 +
                            'rem; height: ' +
                            (seatInfo.maxrow * 60) / 75 +
                            'rem;'
                        "
                    >
                        <img
                            @click="
                                selectSeat(index, item.flag, item.lovegroup)
                            "
                            v-for="(item, index) in seatList"
                            :key="item.seatid"
                            :style="
                                'top: ' +
                                (item.row - 1) * 0.8 +
                                'rem; left: ' +
                                (item.column - 1) * 0.8 +
                                'rem;'
                            "
                            :src="
                                item.status == 0 && item.flag == 0
                                    ? imgList[1].path
                                    : item.status == 0 && item.flag == 1
                                    ? imgList[4].path
                                    : item.status == 0 && item.flag == 2
                                    ? imgList[7].path
                                    : item.is_selected && item.flag == 0
                                    ? imgList[2].path
                                    : item.is_selected && item.flag == 1
                                    ? imgList[5].path
                                    : item.is_selected && item.flag == 2
                                    ? imgList[8].path
                                    : item.flag == 0 && item.areaPic
                                    ? item.areaPic
                                    : item.flag == 0
                                    ? imgList[0].path
                                    : item.flag == 1 && item.areaPic
                                    ? item.areaPic
                                    : item.flag == 1
                                    ? imgList[3].path
                                    : item.flag == 2 && item.areaPic
                                    ? item.areaPic
                                    : imgList[6].path
                            "
                            :class="
                                (item.flag == 1 && 'couple_left') ||
                                (item.flag == 2 && 'couple_right')
                            "
                        />
                    </div>
                </div>
            </div>
            <!-- 座位 不规则排列 -->
            <div v-if="!seatInfo.regular" class="seatWrap">
                <!-- 座位行标 -->
                <ul class="rowMark">
                    <li v-for="(item, index) in rowArr" :key="index">
                        {{ item }}
                    </li>
                </ul>
                <div class="seatMapWrap" v-show="maxColumn">
                    <div
                        class="screenWrap fc ac"
                        :style="'width: ' + (maxColumn * 60 + 20) / 75 + 'rem;'"
                    >
                        <span class="screen"></span>
                        <span class="txt">{{ movieInfo.roomname }} 银幕</span>
                    </div>
                    <div
                        class="seatMap"
                        :style="
                            'width: ' +
                            (maxColumn * 60 + 20) / 75 +
                            'rem; height: ' +
                            (maxRow * 60 + 20) / 75 +
                            'rem;'
                        "
                    >
                        <img
                            @click="
                                selectSeat(index, item.flag, item.lovegroup)
                            "
                            v-for="(item, index) in seatList"
                            :key="item.seatid"
                            :style="
                                'top: ' +
                                (item.toppx - seatInfo.mintoppx) / 37.5 +
                                'rem; left: ' +
                                (item.leftpx - seatInfo.minleftpx) / 37.5 +
                                'rem;'
                            "
                            :src="
                                item.status == 0 && item.flag == 0
                                    ? imgList[1].path
                                    : item.status == 0 && item.flag == 1
                                    ? imgList[4].path
                                    : item.status == 0 && item.flag == 2
                                    ? imgList[7].path
                                    : item.is_selected && item.flag == 0
                                    ? imgList[2].path
                                    : item.is_selected && item.flag == 1
                                    ? imgList[5].path
                                    : item.is_selected && item.flag == 2
                                    ? imgList[8].path
                                    : item.flag == 0 && item.areaPic
                                    ? item.areaPic
                                    : item.flag == 0
                                    ? imgList[0].path
                                    : item.flag == 1 && item.areaPic
                                    ? item.areaPic
                                    : item.flag == 1
                                    ? imgList[3].path
                                    : item.flag == 2 && item.areaPic
                                    ? item.areaPic
                                    : imgList[6].path
                            "
                            :class="
                                (item.flag == 1 && 'couple_left') ||
                                (item.flag == 2 && 'couple_right')
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部菜单 -->
        <transition name="btmMenu">
            <div v-show="selectedList.length > 0" class="btmMenu fc">
                <div class="infoBox fr fw">
                    <div
                        class="seatItem fr ac jsb"
                        v-for="(item, index) in selectedList"
                        :key="index"
                    >
                        <div class="fc">
                            <span>{{ item.name }}</span>
                            <!-- <p>
                                到手价
                                <span
                                    class="price tc"
                                >￥{{canUse ? discountInfo[selectedList.length] * 100 / (selectedList.length * 100) : movieInfo.price * 100 / 10000}}</span>
                            </p>-->
                        </div>
                        <img
                            @click="delSeat(index)"
                            class="closeIco"
                            src="../../../static/imgs/movie/close_grey.png"
                            alt
                        />
                    </div>
                </div>
                <div class="autoSelect fc">
                    <div class="box fr ac jsb">
                        <span>无座自动备选</span>
                        <mt-switch v-model="isAuto"></mt-switch>
                    </div>
                    <p>
                        选择后若您所选的座位已出售，卖家会自动帮您选择相邻的最佳观影区的连号座位
                    </p>
                </div>
                <div class="btnWrap center">
                    <button @click="validateSeats" class="confirmBtn bg_tc">
                        {{
                            canUse
                                ? discountInfo[selectedList.length]
                                : totalPrice
                                ? totalPrice
                                : (movieInfo.price *
                                      100 *
                                      selectedList.length) /
                                  10000
                        }}元 确认选座
                    </button>
                </div>
            </div>
        </transition>
        <div v-show="showErr" class="errLayer fc ac jc">
            <img
                class="notice"
                src="../../../static/imgs/movie/notice.png"
                alt
            />
            <div class="row fr ac jsb">
                <img src="../../../static/imgs/movie/select_seat.png" alt />
                <img src="../../../static/imgs/movie/empty_seat.png" alt />
                <img src="../../../static/imgs/movie/select_seat.png" alt />
            </div>
            <span>座位旁边不要留空</span>
        </div>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Toast, Indicator } from "mint-ui";
export default {
    data() {
        return {
            movieInfo: JSON.parse(this.$route.query.movie_info),
            isAuto: true, //是否无座自动备选
            canUse: false, //是否可以优惠购票
            discountInfo: {}, //优惠价格信息
            seatInfo: {},
            seatList: [],
            maxRow: 0,
            maxColumn: 0,
            selectedList: [],
            cinemaName: this.$route.query.cinema_name,
            phoneNo: this.getLocal("phoneNo"),
            seatsArr: [],
            seatsIdArr: [],
            imgList: [
                {
                    path: require("../../../static/imgs/movie/seat_selectable.png"),
                    name: "可选",
                },
                {
                    path: require("../../../static/imgs/movie/seat_sold.png"),
                    name: "已售",
                },
                {
                    path: require("../../../static/imgs/movie/seat_selected.png"),
                    name: "已选",
                },
                {
                    path: require("../../../static/imgs/movie/seat_couple_selectable_left.png"),
                    name: "情侣座左可选",
                },
                {
                    path: require("../../../static/imgs/movie/seat_couple_sold_left.png"),
                    name: "情侣座左已售",
                },
                {
                    path: require("../../../static/imgs/movie/seat_couple_selected_left.png"),
                    name: "情侣座左已选",
                },
                {
                    path: require("../../../static/imgs/movie/seat_couple_selectable_right.png"),
                    name: "情侣座右可选",
                },
                {
                    path: require("../../../static/imgs/movie/seat_couple_sold_right.png"),
                    name: "情侣座右已售",
                },
                {
                    path: require("../../../static/imgs/movie/seat_couple_selected_right.png"),
                    name: "情侣座右已选",
                },
            ],
            showErr: false,
            rowArr: [],
            txid: this.$global.txid,
            areaArr: [],
            picArr: [
                { path: require("../../../static/imgs/movie/seat/1.png") },
                { path: require("../../../static/imgs/movie/seat/2.png") },
                { path: require("../../../static/imgs/movie/seat/3.png") },
                { path: require("../../../static/imgs/movie/seat/4.png") },
                { path: require("../../../static/imgs/movie/seat/5.png") },
            ],
            rightPicArr: [
                { path: require("../../../static/imgs/movie/seat/1R.png") },
                { path: require("../../../static/imgs/movie/seat/2R.png") },
                { path: require("../../../static/imgs/movie/seat/3R.png") },
                { path: require("../../../static/imgs/movie/seat/4R.png") },
                { path: require("../../../static/imgs/movie/seat/5R.png") },
            ],
            leftPicArr: [
                { path: require("../../../static/imgs/movie/seat/1L.png") },
                { path: require("../../../static/imgs/movie/seat/2L.png") },
                { path: require("../../../static/imgs/movie/seat/3L.png") },
                { path: require("../../../static/imgs/movie/seat/4L.png") },
                { path: require("../../../static/imgs/movie/seat/5L.png") },
            ],
            totalPrice: 0,
        };
    },
    components: {
        navBar,
    },
    computed: {
        formatTime: function () {
            return this.movieInfo.playtime.slice(0, 16);
        },
    },
    created() {
        console.log(this.movieInfo);
        if (
            JSON.stringify(this.movieInfo) != "{}" &&
            this.movieInfo.areaPrice
        ) {
            let areaArr = this.movieInfo.areaPrice.split(";");
            for (let i in areaArr) {
                let arr = areaArr[i].split(","),
                    obj = {};
                for (let j of arr) {
                    let idx = j.indexOf(":");
                    let key = j.substring(0, idx),
                        val = j.substring(idx + 1);
                    obj[key] = val;
                }
                obj["realPrice"] = parseFloat(obj.price);
                obj["idx"] = i;
                areaArr[i] = obj;
            }
            this.areaArr = areaArr;
            console.log(areaArr);
        }
        this.getSeatInfo();
        this.getSeatNum();
        if (!this.getLocal("phoneNo")) {
            this.getMemberInfo().then((res) => {
                if (res.success) {
                    this.phoneNo = res.data.member.mobile;
                    this.setLocal("phoneNo", res.data.member.mobile);
                }
            });
        }
    },
    methods: {
        getSeatInfo() {
            Indicator.open("加载中...");
            this.$post({
                // method: "movie.openplay.seat",
                method: "movie.opi.seat",
                opiid: this.movieInfo.opiid,
            }).then((res) => {
                Indicator.close();
                if (res.success) {
                    if (this.areaArr.length) {
                        for (let i of res.data.seatlist) {
                            for (let j of this.areaArr) {
                                if (j.area == i.area) {
                                    // i.realPrice = parseFloat(j.price) + parseFloat(j.serviceFee);
                                    i.realPrice = parseFloat(j.price);
                                    if (i.flag == 1) {
                                        i.areaPic = this.leftPicArr[j.idx].path;
                                    } else if (i.flag == 2) {
                                        i.areaPic = this.rightPicArr[
                                            j.idx
                                        ].path;
                                    } else {
                                        i.areaPic = this.picArr[j.idx].path;
                                    }
                                }
                            }
                        }
                    }
                    this.seatInfo = res.data.opidetail;
                    this.seatList = res.data.seatlist;
                    if (!res.data.opidetail.regular) {
                        this.maxRow =
                            (res.data.opidetail.maxtoppx -
                                res.data.opidetail.mintoppx) /
                                30 +
                            1;
                        this.maxColumn =
                            (res.data.opidetail.maxleftpx -
                                res.data.opidetail.minleftpx) /
                                30 +
                            1;
                    }
                    this.scrollToCenter();
                    // 座位行标
                    let rowArr = [];
                    let max_row = res.data.opidetail.regular
                        ? res.data.opidetail.maxrow
                        : (res.data.opidetail.maxtoppx -
                              res.data.opidetail.mintoppx) /
                              30 +
                          1;
                    for (let i = 0; i < max_row; i++) {
                        for (let j = 0; j < res.data.seatlist.length; j++) {
                            if (
                                res.data.opidetail.regular &&
                                res.data.seatlist[j].row - 1 == i
                            ) {
                                rowArr[i] = res.data.seatlist[j].rowname;
                                break;
                            } else if (
                                !res.data.opidetail.regular &&
                                (res.data.seatlist[j].toppx -
                                    res.data.opidetail.mintoppx) /
                                    30 ==
                                    i
                            ) {
                                rowArr[i] = res.data.seatlist[j].rowname;
                                break;
                            } else {
                                rowArr[i] = "";
                            }
                        }
                    }
                    this.rowArr = rowArr;
                    console.log(rowArr);
                    if (!res.data.opidetail.regular) {
                        for (let i = 0; i < res.data.seatlist.length; i++) {
                            this.seatList[i].column =
                                (res.data.seatlist[i].leftpx -
                                    res.data.opidetail.minleftpx) /
                                30;
                            this.seatList[i].row =
                                (res.data.seatlist[i].toppx -
                                    res.data.opidetail.mintoppx) /
                                30;
                        }
                    }
                }
            });
        },
        // 获取优惠活动能购买座位数
        getSeatNum() {
            console.log("movieInfo", this.movieInfo);
            if (this.movieInfo.sdid && this.getLocal("auth_code")) {
                this.$post({
                    method: "movie.openplay.seatnum2amount",
                    sdid: this.movieInfo.sdid,
                    opiid: this.movieInfo.opiid,
                    auth_code: this.getLocal("auth_code"),
                }).then((res) => {
                    if (res.success) {
                        this.canUse = res.data.canUse;
                        this.discountInfo = res.data.num2amount;
                    }
                });
            }
        },
        selectSeat(index, flag, lovegroup) {
            let number = lovegroup
                    ? lovegroup.substring(0, lovegroup.length - 1)
                    : "",
                position = lovegroup
                    ? lovegroup.substring(lovegroup.length - 1)
                    : "";
            let oppsite = position == "R" ? "L" : position == "L" ? "R" : "";
            let target = number + oppsite;
            if (this.seatList[index].status == 0) {
                return;
            }
            if (
                this.selectedList.length == this.seatInfo.maxcanbuy &&
                !this.seatList[index].is_selected
            ) {
                Toast({
                    message: "最多可选" + this.seatInfo.maxcanbuy + "个座位",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }

            if (!flag) {
                this.$set(
                    this.seatList[index],
                    "is_selected",
                    this.seatList[index].is_selected ? false : true
                );
            } else {
                if (
                    this.selectedList.length >= this.seatInfo.maxcanbuy - 1 &&
                    !this.seatList[index].is_selected
                ) {
                    Toast({
                        message:
                            "最多可选" + this.seatInfo.maxcanbuy + "个座位",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                    return;
                }
                this.$set(
                    this.seatList[index],
                    "is_selected",
                    this.seatList[index].is_selected ? false : true
                );
                if (lovegroup) {
                    for (let i in this.seatList) {
                        if (this.seatList[i].lovegroup == target) {
                            this.$set(
                                this.seatList[i],
                                "is_selected",
                                this.seatList[index].is_selected
                            );
                            break;
                        }
                    }
                } else {
                    Toast({
                        message: "数据有误",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                    return;
                }
            }

            if (this.seatList[index].is_selected) {
                if (this.seatList[index].row > 5) {
                    window.scrollTo(0, 1000);
                }
                this.selectedList.push(this.seatList[index]);
                if (flag) {
                    for (let i of this.seatList) {
                        if (i.lovegroup == target) {
                            this.selectedList.push(i);
                        }
                    }
                }
            } else {
                let idx = this.selectedList.indexOf(this.seatList[index]);
                this.selectedList.splice(idx, 1);
                if (flag) {
                    for (let i in this.selectedList) {
                        if (this.selectedList[i].lovegroup == target) {
                            this.selectedList.splice(i, 1);
                        }
                    }
                }
            }

            let totalPrice = 0;
            for (let i of this.selectedList) {
                totalPrice += i.realPrice
                    ? i.realPrice
                    : this.movieInfo.price / 100;
            }
            this.totalPrice = totalPrice.toFixed(1);
        },
        delSeat(index) {
            let idx = this.seatList.indexOf(this.selectedList[index]);
            let flag = this.selectedList[index].flag;
            let lovegroup = this.selectedList[index].lovegroup
                ? this.selectedList[index].lovegroup
                : "";
            let number = lovegroup
                    ? lovegroup.substring(0, lovegroup.length - 1)
                    : "",
                position = lovegroup
                    ? lovegroup.substring(lovegroup.length - 1)
                    : "";
            let oppsite = position == "R" ? "L" : position == "L" ? "R" : "";
            let target = number + oppsite;
            this.$set(
                this.seatList[idx],
                "is_selected",
                this.seatList[idx].is_selected ? false : true
            );
            this.selectedList.splice(index, 1);
            if (flag) {
                for (let i in this.selectedList) {
                    if (this.selectedList[i].lovegroup == target) {
                        let seatIdx = this.seatList.indexOf(this.selectedList[i]);
                        this.$set(
                            this.seatList[seatIdx],
                            "is_selected",
                            this.seatList[seatIdx].is_selected ? false : true
                        );
                        this.selectedList.splice(i, 1);
                        break
                    }
                }
            }
            let totalPrice = 0;
            for (let i of this.selectedList) {
                totalPrice += i.realPrice
                    ? i.realPrice
                    : this.movieInfo.price / 100;
            }
            this.totalPrice = totalPrice.toFixed(1);
        },
        // 确认选座
        confirmSeats() {
            // let movie_info = this.$route.query.movie_info
            // let selected_list = JSON.stringify(this.selectedList)
            // this.$router.push({path: '/orderInfo', query: {movie_info: movie_info, selected_list: selected_list}})
            this.setLocal(
                "movie_info",
                JSON.parse(this.$route.query.movie_info)
            );
            this.setLocal("selected_list", this.selectedList);
            let sdid = this.canUse ? this.movieInfo.sdid : "";
            let discountPrice = this.canUse
                ? this.discountInfo[this.selectedList.length]
                : "";
            this.$router.push({
                path: "/orderInfo",
                query: { sdid: sdid, discountPrice: discountPrice, totalPrice: this.totalPrice },
            });
        },
        showError() {
            this.showErr = true;
            setTimeout(() => {
                this.showErr = false;
            }, 2500);
        },
        scrollToCenter() {
            this.$nextTick(() => {
                let seatBox = document.getElementsByClassName("seatMapWrap");
                seatBox[0].scrollLeft = seatBox[0].offsetWidth * 0.3;
            });
        },
        // 检查座位之间是否留空
        validateSeats() {
            let validateArr = [],
                validateTxt = "";
            for (let i of this.selectedList) {
                let tempArr = [];
                for (let j of this.seatList) {
                    if (i.rowname == j.rowname) {
                        tempArr.push(j);
                    }
                }
                for (let k = 0; k < tempArr.length; k++) {
                    for (let l = k + 1; l < tempArr.length; l++) {
                        if (tempArr[k].column > tempArr[l].column) {
                            let temp = {};
                            temp = tempArr[k];
                            tempArr[k] = tempArr[l];
                            tempArr[l] = temp;
                        }
                    }
                }
                if (validateArr.indexOf(JSON.stringify(tempArr)) < 0) {
                    validateArr.push(JSON.stringify(tempArr));
                }
            }
            validateArr = validateArr.map((item) => {
                return JSON.parse(item);
            });
            console.log(validateArr);
            for (let row of validateArr) {
                for (let idx in row) {
                    if (row[idx].is_selected) {
                        validateTxt += "B";
                    } else if (row[idx].status) {
                        validateTxt += "A";
                    } else if (!row[idx].status) {
                        validateTxt += "S";
                    }
                    if (idx < row.length - 1) {
                        if (
                            Math.abs(
                                row[Number(idx) + 1].column - row[idx].column
                            ) > 1
                        ) {
                            for (
                                let i = 0;
                                i <
                                Math.abs(
                                    row[Number(idx) + 1].column -
                                        row[idx].column
                                ) -
                                    1;
                                i++
                            ) {
                                validateTxt += "O";
                            }
                        }
                    }
                }
                validateTxt += "@";
            }
            console.log(validateTxt);
            this.$post({
                method: "movie.seat.validposition",
                rowsseats: validateTxt.slice(0, validateTxt.length - 1),
            }).then((res) => {
                if (res.success) {
                    this.confirmOrder();
                } else {
                    this.showError();
                    return;
                }
            });
        },
        // 确认订单
        confirmOrder() {
            this.seatsArr = [];
            this.seatsIdArr = [];
            for (let i of this.selectedList) {
                this.seatsArr.push(i.name);
                this.seatsIdArr.push(i.seatid);
            }
            let isCoupleSeat = "";
            for (let j of this.selectedList) {
                if (j.flag) {
                    isCoupleSeat = "Y";
                    break;
                }
            }
            Indicator.open("加载中...");
            this.$post({
                method: "member.order.create",
                auth_code: this.getLocal("auth_code"),
                mobile: this.phoneNo,
                opiid: this.selectedList[0].opiid,
                seatids: this.seatsIdArr.join("|"),
                seatnames: encodeURI(this.seatsArr).split(",").join("|"),
                sdid: this.movieInfo.sdid ? this.movieInfo.sdid : "",
                // loveseat: isCoupleSeat,
                txid: this.txid,
                usearea: "Y"
            })
                .then((res) => {
                    Indicator.close();
                    if (res.success) {
                        let tradeno = res.data.tradeno;
                        this.$router.push({
                            path: "/confirmOrder",
                            query: {
                                tradeno: tradeno,
                                seatsTxt: this.seatsTxt,
                                posterUrl: this.movieInfo.logo,
                                ticketNum: this.selectedList.length,
                            },
                        });
                    } else {
                        Toast({
                            message: res.error.desp,
                            position: "middle",
                            duration: 2000,
                            className: "toastBox",
                        });
                    }
                })
                .catch((err) => {
                    Indicator.close();
                });
        },
    },
};
</script>
<style lang="scss">
.selectSeatWrap {
    .header {
        width: 100%;
        height: 228px;
        position: fixed;
        top: 0;
        z-index: 10;
        .movieInfo {
            background-color: #fff;
            border-bottom: 1px solid #dededf;
            padding: 0 30px;
            height: 148px;
            h3 {
                font-size: 32px;
                // margin-bottom: 20px;
                margin: 18px 0;
            }
            p {
                font-size: 24px;
                margin-bottom: 15px;
            }
        }
        .legend {
            width: 100%;
            height: 80px;
            background: #f2f2f2;
            .seatImg {
                width: 22px;
                height: 20px;
                margin: 0 16px;
            }
            .doubleSeatImg {
                width: 38px;
                height: 20px;
                margin: 0 16px;
            }
            span {
                font-size: 22px;
            }
        }
    }

    .seatWrap {
        position: relative;
        padding-top: 278px;
        .rowMark {
            position: absolute;
            width: 36px;
            background-color: rgba(0, 0, 0, 0.4);
            padding: 18px 0;
            border-radius: 18px;
            z-index: 5;
            // top: 76px;
            top: 424px;
            left: 20px;
            li {
                width: 36px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                color: #fff;
                font-size: 28px;
            }
        }
        .seatMapWrap {
            width: 100%;
            overflow-x: scroll;
            .screenWrap {
                margin-left: 120px;
                height: 70px;
                .screen {
                    width: 180px;
                    height: 10px;
                    // line-height: 50px;
                    background-color: #f90040;
                    padding: 0 20px;
                    font-size: 28px;
                }
                .txt {
                    font-size: 24px;
                    color: #999;
                    margin: 14px 0 20px 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .seatMap {
                position: relative;
                margin: 100px 0 600px 120px;
                padding-right: 20px;
                img {
                    position: absolute;
                    width: 48px;
                    height: 44px;
                }
                .couple_left {
                    transform: translateX(6px);
                }
                .couple_right {
                    transform: translateX(-6px);
                }
            }
            .seatMap:before,
            .seatMap:after {
                content: "";
                position: absolute;
                border-style: dotted;
                border-color: #e42f46;
                border-width: 0;
                z-index: 2;
            }
            .seatMap:before {
                width: 0;
                height: 100%;
                border-left-width: 1px;
                left: 50%;
                top: 0;
            }
            .seatMap:after {
                width: 100%;
                height: 0;
                border-top-width: 1px;
                top: 50%;
                left: 0;
            }
        }
        .seatMapWrap::-webkit-scrollbar {
            display: none;
        }
    }

    .btmMenu {
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 6;
        transform: translateY(0);
        .infoBox {
            width: 100%;
            padding: 25px 30px 0 30px;
            box-sizing: border-box;
            background-color: #fff;
            .selectedInfo {
                width: 428px;
                .seats {
                    span {
                        width: 122px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        margin: 16px 16px 0 0;
                        border: 1px solid #b0b8c1;
                        border-radius: 10px;
                    }
                }
            }
            .priceInfo {
                width: 230px;
                .price {
                    font-size: 28px;
                    margin-top: 16px;
                    strong {
                        font-size: 36px;
                        color: #e42f46;
                    }
                }
            }
            .seatItem {
                min-width: 180px;
                height: 80px;
                background: #f2f2f2;
                margin: 0 35px 25px 0;
                padding: 0 15px;
                font-size: 24px;
                border-radius: 8px;
                p {
                    margin-top: 4px;
                    .price {
                        font-size: 24px;
                    }
                }
                .closeIco {
                    width: 30px;
                    height: 40px;
                    padding: 10px 0 10px 10px;
                    border-left: 1px dashed #999;
                }
            }
        }
        .autoSelect {
            background: #fff;
            .box {
                width: 100%;
                height: 90px;
                padding: 0 30px;
                box-sizing: border-box;
                span {
                    font-size: 28px;
                }
                .mint-switch-input:checked + .mint-switch-core {
                    border-color: #00cda7;
                    background-color: #00cda7;
                }
            }
            p {
                font-size: 24px;
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                line-height: 34px;
            }
        }
        .btnWrap {
            width: 100%;
            height: 180px;
            background: #fff;
            .confirmBtn {
                width: 630px;
                height: 98px;
                color: #fff;
                font-size: 32px;
                border-radius: 49px;
            }
        }
    }
    .btmMenu-enter {
        transform: translateY(270px);
    }
    .btmMenu-enter-active {
        transition: all 0.5s;
    }
    .errLayer {
        width: 460px;
        height: 300px;
        position: fixed;
        top: 400px;
        left: 145px;
        z-index: 20;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 10px;
        .notice {
            width: 45px;
            height: 45px;
            margin: 20px 0;
        }
        .row {
            width: 260px;
            img {
                width: 68px;
                height: 66px;
            }
        }
        span {
            color: #fff;
            font-size: 30px;
            margin: 30px 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/selectSeat.vue